import React from 'react';

export interface CardTitle {
    children: React.ReactNode;
    className?: string;
}

export const CardTitle = ({ children, className }: CardTitle) => (
    <div className={`mb-2 border-bottom card-body-title ${className}`}>
        <h3 className="pb-0 mb-2">{children}</h3>
    </div>
);

CardTitle.defaultProps = {
    className: '',
};

export default CardTitle;